if (typeof window.Ecotax === 'undefined') {
    window.Ecotax = {
        ProductTypeEnum: {
            RANGEMENT: 'Rangement',
            FACADE_DE_PLACARD: 'Façade de placard',
            CLOISON: 'Cloison',
        },
        metafields: {},
        init: (productId, productType, metafields, basePrice, compareAtPrice) => {
            window.Ecotax.metafields = metafields;

            const defaultLargeur = window.Ecotax.metafields.largeur ?? 0;
            const defaultHauteur = window.Ecotax.metafields.hauteur ?? 0;

            let largeurFacade = defaultLargeur;
            let largeurAgrandissementFacade = defaultLargeur;
            let largeurReductionFacade = defaultLargeur;
            let hauteurFacade = defaultHauteur;

            const MADYesElt = window.Ecotax.getOptionizeOptionElt("Mise à dimensions", productId, "Oui");
            if (MADYesElt) {

                const activateMAD = () => {
                    window.Ecotax.updateEcoTaxe(productId, productType,
                        basePrice, compareAtPrice,
                        largeurFacade, hauteurFacade
                    );

                    const LAORAElt = window.Ecotax.getOptionizeOptionElt("Largeur Agrandissement ou réductions", productId, "Agrandissement");
                    if (LAORAElt) {
                        const activateLAORA = () => {
                            largeurFacade = largeurAgrandissementFacade;
                            window.Ecotax.updateEcoTaxe(productId, productType,
                                basePrice, compareAtPrice,
                                largeurFacade, hauteurFacade
                            );
                            const MADLargeurAgrandissementElt = window.Ecotax.getOptionizeOptionElt("LARGEUR MAD Agrandissement", productId);
                            //MADLargeurAgrandissementElt.removeEventListener("change");
                            MADLargeurAgrandissementElt.addEventListener("change", function (e) {
                                largeurAgrandissementFacade = parseFloat(e.target.value);
                                largeurFacade = largeurAgrandissementFacade;
                                window.Ecotax.updateEcoTaxe(productId, productType,
                                    basePrice, compareAtPrice,
                                    largeurAgrandissementFacade, hauteurFacade
                                );
                            });
                        };
                        LAORAElt.removeEventListener("change", activateLAORA);
                        LAORAElt.addEventListener("change", activateLAORA);
                        if (LAORAElt.checked) {
                            activateLAORA();
                        }
                    }

                    const LAORRElt = window.Ecotax.getOptionizeOptionElt("Largeur Agrandissement ou réductions", productId, "Réduction");
                    if (LAORRElt) {
                        const activateLAORR = () => {
                            largeurFacade = largeurReductionFacade;
                            window.Ecotax.updateEcoTaxe(productId, productType,
                                basePrice, compareAtPrice,
                                largeurFacade, hauteurFacade
                            );
                            const MADLargeurReductionElt = window.Ecotax.getOptionizeOptionElt("Largeur MAD - Réduction", productId);
                            //MADLargeurReductionElt.removeEventListener("change");
                            MADLargeurReductionElt.addEventListener("change", function (e) {
                                largeurReductionFacade = parseFloat(e.target.value);
                                largeurFacade = largeurReductionFacade;
                                window.Ecotax.updateEcoTaxe(productId, productType,
                                    basePrice, compareAtPrice,
                                    largeurReductionFacade, hauteurFacade
                                );
                            });
                        };
                        LAORRElt.removeEventListener("change",activateLAORR);
                        LAORRElt.addEventListener("change", activateLAORR);
                        if (LAORRElt.checked) {
                            activateLAORR();
                        }
                    }

                    if (productType === window.Ecotax.ProductTypeEnum.RANGEMENT || productType === window.Ecotax.ProductTypeEnum.CLOISON || productType === window.Ecotax.ProductTypeEnum.FACADE_DE_PLACARD) {
                        const MADHauteurElt = window.Ecotax.getOptionizeOptionElt("Hauteur MAD", productId);
                        if (MADHauteurElt) {
                            //MADHauteurElt.removeEventListener("change");
                            MADHauteurElt.addEventListener("change", function (e) {
                                hauteurFacade = parseFloat(e.target.value);
                                window.Ecotax.updateEcoTaxe(productId, productType,
                                    basePrice, compareAtPrice,
                                    largeurFacade, hauteurFacade
                                );
                            });
                        }
                    }
                };

                MADYesElt.removeEventListener("change",activateMAD);
                MADYesElt.addEventListener("change", activateMAD);
                if (MADYesElt.checked) {
                    activateMAD();
                }
            }

            const MADNoElt = window.Ecotax.getOptionizeOptionElt("Mise à dimensions", productId, "Non");
            if (MADNoElt) {
                MADNoElt.addEventListener("change", function () {
                    window.Ecotax.updateEcoTaxe(productId, productType,
                        basePrice, compareAtPrice,
                        largeurFacade, hauteurFacade
                    );
                });
            }
        },

        getOptionizeOptionElt: (option, productId, value) => {
            const optionize = document.getElementById('optionize-option-set-' + productId);
            if (optionize) {
                const optionizeConfigJSON = document.getElementById('optionize-option-set-' + productId).innerHTML;
                if (optionizeConfigJSON) {
                    const optionizeConfig = JSON.parse(optionizeConfigJSON);
                    if (optionizeConfig) {
                        let optionizeOption = optionizeConfig.options.find(o => o.name.toLowerCase().includes(option.toLowerCase()));
                        if (!optionizeOption) {
                            optionizeOption = optionizeConfig.options.filter(o => typeof o.label !== "undefined").find(o => o.label.toLowerCase().includes(option.toLowerCase()));
                        }
                        if (value) {
                            if (optionizeOption) {
                                const id = optionizeOption.values.find(v => v.label.toLowerCase().includes(value.toLowerCase())).id;
                                const ozptionizeElements = Array.from(document.querySelectorAll("#" + id));
                                let element = null;
                                for (const optionizeElement of ozptionizeElements) {
                                    const parentElement = optionizeElement.parentElement;
                                    if (parentElement) {
                                        const label = parentElement.querySelector('.oz__option-value-label');
                                        if (label) {
                                            const labelText = label.textContent.trim().toLowerCase();
                                            if (labelText.includes(value.toLowerCase())) {
                                                element = optionizeElement;
                                                break;
                                            }
                                        }
                                    }
                                }
                                return element;
                            }
                        } else if (optionizeOption) {
                            const id = optionizeOption.id;
                            return document.getElementById(id);
                        }
                    }
                }
            }
            return null;
        },

        /**
         * Calculates the eco tax for Aménagement and Rangement
         * @param H {number} - The height of the product
         * @param L {number} - The width of the product
         * @return {number}
         */
        calculateAREcoTax: (H, L) => {
            // Step 1: Calculate the mass
            const a = parseFloat(window.Ecotax.metafields.propriete_ecocontribution_poids_coefficient_a ?? '0');
            const b = parseFloat(window.Ecotax.metafields.propriete_ecocontribution_poids_coefficient_b ?? '0');
            const c = parseFloat(window.Ecotax.metafields.propriete_ecocontribution_poids_coefficient_c ?? '0');
            const d = parseFloat(window.Ecotax.metafields.propriete_ecocontribution_poids_coefficient_d ?? '0');

            const mass = (a * H) + (b * L) + (c * H * L) + d;

            // Step 2: Calculate the eco tax based on the mass
            if (mass < 0.1) {
                return 0.02;
            } else if (mass < 0.25) {
                return 0.03;
            } else if (mass < 0.5) {
                return 0.05;
            } else if (mass < 1) {
                return 0.09;
            } else if (mass < 2) {
                return 0.16;
            } else if (mass < 5) {
                return 0.28;
            } else if (mass < 10) {
                return 0.53;
            } else if (mass < 20) {
                return 1.13;
            } else if (mass < 30) {
                return 1.65;
            } else if (mass < 40) {
                return 2.36;
            } else if (mass < 60) {
                return 3.15;
            } else if (mass < 100) {
                return 5.25;
            } else if (mass < 150) {
                return 9.45;
            } else if (mass < 200) {
                return 13.23;
            } else if (mass < 250) {
                return 17.01;
            } else if (mass < 300) {
                return 20.79;
            } else {
                return 30.24;
            }
        },

        /**
         * Calculates the eco tax for Facade de placard
         * @param H {number} - The height of the product
         * @param L {number} - The width of the facade
         * @return {number}
         */
        calculateFPEcoTax: (H,L) => {
            /** Ancien calcul en fonction de la largeur du vantail
            const customEcotaxeLimite1 = parseFloat(window.Ecotax.metafields.ecotaxe_limite_1 ?? '0');
            const customEcotaxeLimite2 = parseFloat(window.Ecotax.metafields.ecotaxe_limite_2 ?? '0');
            const customEcotaxe1 = parseFloat(window.Ecotax.metafields.ecotaxe_1 ?? '0');
            const customEcotaxe2 = parseFloat(window.Ecotax.metafields.ecotaxe_2 ?? '0');
            const customEcotaxe3 = parseFloat(window.Ecotax.metafields.ecotaxe_3 ?? '0');

            if (L <= customEcotaxeLimite1) {
                return customEcotaxe1;
            } else if (customEcotaxeLimite1 < L && L <= customEcotaxeLimite2) {
                return customEcotaxe2;
            } else if (customEcotaxeLimite2 < L) {
                return customEcotaxe3;
            }
            */

            //Nouveau calcul juillet 2026 pour calcul au poids réel

            const custom_nombre_portes = parseFloat(window.Ecotax.metafields.nombre_portes ?? '0');
            const custom_poids_poignee = parseFloat(window.Ecotax.metafields.poids_poignee ?? '0');
            const custom_poids_pdc = parseFloat(window.Ecotax.metafields.poids_pdc ?? '0');
            const custom_modele_traverse = window.Ecotax.metafields.modele_traverse ?? '';
            const custom_poids_traverse = parseFloat(window.Ecotax.metafields.poids_traverse ?? '0');
            const custom_poids_mecanisme = parseFloat(window.Ecotax.metafields.poids_mecanisme ?? '0');
            const custom_caracteristiques_epaisseur_panneau = window.Ecotax.metafields.caracteristiques_epaisseur_panneau ?? '';
            const epaisseur_panneau = parseFloat(custom_caracteristiques_epaisseur_panneau.substring(0, 2)) || 0;
            const custom_propriete_donnees_tech_type_ouverture = window.Ecotax.metafields.propriete_donnees_tech_type_ouverture ?? ''; 
            const custom_matiere_poignee = window.Ecotax.metafields.matiere_poignee ?? '';

            const masse_surfacique_verre = 9.80;
            const masse_surfacique_cuir_10 =  6.10;
            const masse_surfacique_cuir_12 =  8.20;
            const masse_surfacique_mela_6 = 4.64;
            const masse_surfacique_mela_8 = 5.30;
            const masse_surfacique_mela_10 = 7.40;
            const masse_surfacique_mela_12 = 8.56;
            const masse_surfacique_structure_10 = 7.10;
            const masse_surfacique_structure_12 = 9.20;
            const masse_surfacique_kabourg = 9.18;

            let hauteur_vantail = 0;
            if (custom_propriete_donnees_tech_type_ouverture === "coulissante" && custom_matiere_poignee === "ACIER") {
                hauteur_vantail = H - 55;
            } else if (custom_propriete_donnees_tech_type_ouverture === "coulissante" && custom_matiere_poignee === "ALU") {
                hauteur_vantail = H - 66;
            } else if (custom_propriete_donnees_tech_type_ouverture === "pivotante" && custom_matiere_poignee === "ACIER") {
                hauteur_vantail = H - 35;
            } else if (custom_propriete_donnees_tech_type_ouverture === "pivotante" && custom_matiere_poignee === "ALU") {
                hauteur_vantail = H - 45;
            } else if (custom_propriete_donnees_tech_type_ouverture === "pliante") {
                hauteur_vantail = H - 45;
            } else {
                hauteur_vantail = 0;
            }

            const largeur_vantail = parseFloat((L / custom_nombre_portes) ?? '0');
            const poids_pdc = custom_poids_pdc * 2 * largeur_vantail / 1000;
            const poids_poignee = custom_poids_poignee * 2 * hauteur_vantail / 1000;

            let ecotaxe = 0;
            for (let porte = 1; porte < 5; porte++) {
                if (porte <= custom_nombre_portes) {
                    let key_nombre_traverses = "nombre_traverses_vtl" + porte;
                    let nombre_traverses = parseFloat(window.Ecotax.metafields[key_nombre_traverses] ?? '0');

                    let surface_vantail = 0;
                    if (custom_matiere_poignee === "ACIER") {
                        surface_vantail = (hauteur_vantail / 1000)*(largeur_vantail / 1000);
                    } else if (custom_matiere_poignee === "ALU" && custom_modele_traverse ==="XXL+Enjoliv.") {
                        const deduction_traverses = nombre_traverses * 90;
                        const hauteur_hors_traverse = hauteur_vantail - deduction_traverses;
                        surface_vantail = (hauteur_hors_traverse / 1000)*(largeur_vantail / 1000);
                    } else if (custom_matiere_poignee === "ALU" && custom_modele_traverse !=="XXL+Enjoliv.") {
                        const hauteur_hors_pdc = hauteur_vantail - 26;
                        surface_vantail = (hauteur_hors_pdc / 1000)*(largeur_vantail / 1000);
                    } else {
                        surface_vantail = 0;
                    }

                    let poids_traverse = custom_poids_traverse * nombre_traverses * largeur_vantail / 1000;
                    let poids_perturbateur = 0;
                    let total_poids_decors = 0;

                    for (let decor = 1; decor < 5; decor++) {
                        let key_surface = "surface_matiere" + decor + "_vtl" + porte;
                        let surface_matiere = parseFloat(window.Ecotax.metafields[key_surface] ?? '0');
                        let matiere = '';

                        if (porte === 1) {
                            let key_matiere = "matiere" + decor + "_vtl1_faceA";
                            matiere = window.Ecotax.metafields[key_matiere] ?? '';
                            if (!matiere) {
                                key_matiere = "matiere" + decor + "_vtl1";
                                matiere = window.Ecotax.metafields[key_matiere] ?? '';
                            }
                        } else {
                            const key_matiere = "matiere" + decor + "_vtl" + porte;
                            matiere = window.Ecotax.metafields[key_matiere] ?? '';
                        }

                        let masse_surfacique_matiere = 0;
                        let masse_surfacique_souscouche = 0;
                        let is_perturbateur = false;

                        switch (matiere) {
                            case "Mélaminé":                        
                                if (epaisseur_panneau === 10) {
                                    masse_surfacique_matiere = masse_surfacique_mela_10;
                                } else if (epaisseur_panneau === 12) {
                                    masse_surfacique_matiere = masse_surfacique_mela_12;
                                }
                                break;
                        
                            case "Verre":
                            case "Miroir":
                                masse_surfacique_matiere = masse_surfacique_verre;
                                is_perturbateur = true;

                                if (epaisseur_panneau === 12) {
                                    masse_surfacique_souscouche = masse_surfacique_mela_8;
                                } else if (epaisseur_panneau === 10) {
                                    masse_surfacique_souscouche = masse_surfacique_mela_6;
                                }
                                break;
                            
                            case "Vitre":
                                masse_surfacique_matiere = masse_surfacique_verre;
                                is_perturbateur = true;
                                break;

                            case "Cuir":
                                if (epaisseur_panneau === 12) {
                                    masse_surfacique_matiere = masse_surfacique_cuir_12;
                                } else if (epaisseur_panneau === 10) {
                                    masse_surfacique_matiere = masse_surfacique_cuir_10;
                                }
                                break;

                            case "Décor Structuré":
                                if (epaisseur_panneau === 12) {
                                    masse_surfacique_matiere = masse_surfacique_structure_12;
                                } else if (epaisseur_panneau === 10) {
                                    masse_surfacique_matiere = masse_surfacique_structure_10;
                                }
                                break;

                            case "Kabourg":
                                masse_surfacique_matiere = masse_surfacique_kabourg;
                                break;
                        }

                        let poids_matiere = masse_surfacique_matiere * surface_vantail * surface_matiere;
                        let poids_souscouche = masse_surfacique_souscouche * surface_vantail * surface_matiere;
                        let poids_decor = poids_matiere + poids_souscouche;

                        total_poids_decors = total_poids_decors + poids_decor;

                        if (is_perturbateur) {
                            poids_perturbateur = poids_perturbateur + poids_matiere;
                        }
                    }

                    let poids_vtl = poids_pdc + poids_poignee + poids_traverse + custom_poids_mecanisme + total_poids_decors;
                    let pourcentage_perturbateur = 0;
                    if (poids_vtl > 0) {
                        pourcentage_perturbateur = poids_perturbateur / poids_vtl;
                    }

                    let ecotaxe_vtl = 0;

                    if (pourcentage_perturbateur <= 0) {
                        if (poids_vtl < 5) {
                            ecotaxe_vtl = 0.28;
                        } else if (poids_vtl < 10) {
                            ecotaxe_vtl = 0.53;
                        } else if (poids_vtl < 20) {
                            ecotaxe_vtl = 1.13;
                        } else if (poids_vtl < 30) {
                            ecotaxe_vtl = 1.65;
                        } else if (poids_vtl < 40) {
                            ecotaxe_vtl = 2.36;
                        } else if (poids_vtl < 60) {
                            ecotaxe_vtl = 3.15;
                        } else {
                            ecotaxe_vtl = 5.25;
                        }
                    } else if (pourcentage_perturbateur <= 0.20) {
                        if (poids_vtl < 5) {
                            ecotaxe_vtl = 0.68;
                        } else if (poids_vtl < 10) {
                            ecotaxe_vtl = 1.31;
                        } else if (poids_vtl < 20) {
                            ecotaxe_vtl = 2.73;
                        } else if (poids_vtl < 30) {
                            ecotaxe_vtl = 4.54;
                        } else if (poids_vtl < 40) {
                            ecotaxe_vtl = 6.26;
                        } else if (poids_vtl < 60) {
                            ecotaxe_vtl = 8.58;
                        } else {
                            ecotaxe_vtl = 13.53;
                        }
                    } else {
                        if (poids_vtl < 5) {
                            ecotaxe_vtl = 0.89;
                        } else if (poids_vtl < 10) {
                            ecotaxe_vtl = 1.87;
                        } else if (poids_vtl < 20) {
                            ecotaxe_vtl = 4.27;
                        } else if (poids_vtl < 30) {
                            ecotaxe_vtl = 6.24;
                        } else if (poids_vtl < 40) {
                            ecotaxe_vtl = 8.42;
                        } else if (poids_vtl < 60) {
                            ecotaxe_vtl = 11.94;
                        } else {
                            ecotaxe_vtl = 19.90;
                        }
                    }

                    ecotaxe = ecotaxe + ecotaxe_vtl;
                }
            }

            return ecotaxe;
        },

        formatPrice: (price) => {
            const formattedPrice = price.toLocaleString('fr-FR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });

            return formattedPrice.replace(/\s/g, '.');
        },

        replacePrice: (element, newPrice) => {
            element.innerHTML = element.innerHTML.replace(/[\d.,]+/, window.Ecotax.formatPrice(newPrice));
        },

        updateEcoTaxe: (productId, productType, basePrice, compareAtPrice, L, H) => {
            let largeurFacade = window.Ecotax.metafields.largeur ?? '0';
            let hauteurFacade = window.Ecotax.metafields.hauteur ?? '0';

            const MADYesNoElt = window.Ecotax.getOptionizeOptionElt("Mise à dimensions", productId, "Oui");
            // MAD enabled
            if (MADYesNoElt && MADYesNoElt.classList.contains("oz__option-value--selected")) {
                largeurFacade = L;
                hauteurFacade = H;
            }

            let ecotaxe = 0;
            if (productType === window.Ecotax.ProductTypeEnum.RANGEMENT || productType === window.Ecotax.ProductTypeEnum.CLOISON) {
                ecotaxe = window.Ecotax.calculateAREcoTax(hauteurFacade, largeurFacade) * 1.2;
            } else if (productType === window.Ecotax.ProductTypeEnum.FACADE_DE_PLACARD) {
                ecotaxe = window.Ecotax.calculateFPEcoTax(hauteurFacade, largeurFacade) * 1.2;
            }

            if (ecotaxe > 0) {
                const forms = document.querySelectorAll(`form[data-product-id="${productId}"][action="/cart/add"]`);
                for (const form of forms) {
                    const ecotaxValueInput = form.querySelector('.ecotaxValue');
                    if (ecotaxValueInput) {
                        ecotaxValueInput.value = (ecotaxe * 100).toFixed(2);
                    }
                    const ecotaxLabelInput = form.querySelector('.ecotaxLabel');
                    if (ecotaxLabelInput) {
                        ecotaxLabelInput.value = ecotaxLabelInput.value.replace(/[\d.,]+/, window.Ecotax.formatPrice(ecotaxe));
                    }
                }
                const ecoTaxeElt = document.getElementById('ecotaxe');
                ecoTaxeElt.innerHTML = ecoTaxeElt.innerHTML.replace(/[\d.,]+/, ecotaxe.toFixed(2));
                const regularPriceDiv = document.getElementsByClassName('price__regular');
                if (regularPriceDiv.length > 0) {
                    const regularPrice = regularPriceDiv[0].getElementsByClassName('price-item--regular');
                    if (regularPriceDiv.length > 0) {
                        window.Ecotax.replacePrice(regularPrice[0], basePrice + ecotaxe);
                    }
                }
                const salePriceDiv = document.getElementsByClassName('price__sale');
                if (salePriceDiv.length > 0) {
                    const salePrice = salePriceDiv[0].getElementsByClassName('price-item--sale');
                    if (salePriceDiv.length > 0) {
                        window.Ecotax.replacePrice(salePrice[0], basePrice + ecotaxe);
                    }
                    const regularPrice = salePriceDiv[0].getElementsByClassName('price-item--regular');
                    if (regularPriceDiv.length > 0) {
                        window.Ecotax.replacePrice(regularPrice[0], compareAtPrice + ecotaxe);
                    }
                }
            }
        }
    };


    let lastCallTime = 0;
    const throttleDelay = 300;

    function shouldThrottle() {
        const now = Date.now();
        if (now - lastCallTime < throttleDelay) {
            return true;
        }
        lastCallTime = now;
        return false;
    }

    /**
     * Appelle l'API /update-order pour créer ou mettre à jour un draft order
     * @param {Array} cartItems - Les articles du panier
     * @param {string|null} draftOrderId - L'ID du draft order existant (optionnel)
     * @param {Function} onSuccess - Callback appelé en cas de succès avec (result, token)
     * @param {Function} onError - Callback appelé en cas d'erreur
     * @returns {Promise} - Promise de l'appel fetch
     */
    function updateDraftOrder(cartItems, draftOrderId = null, customerData = null, onSuccess = null, onError = null) {
        const ecocontributionKeyDraftOrder = localStorage.getItem("ecocontribution_key_draft_order") ?? "Dont éco-participation";
        const subpath = Shopify.shop.includes("319d4d-1c") ? "" : Shopify.shop.includes("-paul") ? "-pol" : Shopify.shop.includes("cyril") ? "-cyril" : "";

        const requestBody = {
            cart: { items: cartItems },
            ecocontributionKeyDraftOrder,
            customerData,
        };

        if (draftOrderId) {
            requestBody.draftOrderId = draftOrderId;
        }

        for (const item of requestBody.cart.items) {
            if (item.properties['_oz-addons']) {
                item.properties['_oz-addons'] = item.properties['_oz-addons'].replace(/"/g, '\\"');
            }

        }

        return fetch(`/apps/erp-sync${subpath}/proxy/update-order`, {
            method: "POST",
            body: JSON.stringify(requestBody),
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((res) => res.json())
            .then((result) => {
                if (!result.error && onSuccess) {
                    onSuccess(result);
                } else if (result.error && onError) {
                    onError(result);
                }
                return result;
            })
            .catch((error) => {
                if (onError) {
                    onError(error);
                }
                throw error;
            });
    }

    function setDraftOrderToLocalStorage(token, draftOrderUrl, draftOrderId, updatedAt) {
        if (token && draftOrderUrl && draftOrderId && updatedAt) {
            localStorage.setItem(
                "draftOrder",
                JSON.stringify({
                    [token]: {
                        draftOrderUrl,
                        draftOrderId,
                        updatedAt,
                    },
                })
            );
        }
    }

    function getCustomerData() {
        const customerJsonElt = document.getElementById("customer-json");

        if (customerJsonElt) {
            try {
                const customerData = JSON.parse(customerJsonElt.textContent);
                return customerData;
            } catch (error) {
                return null;
            }
        }

        return null;
    }

    //========= FETCH
    window.fetch = new Proxy(window.fetch, {
        apply: async function (target, that, args) {
            const addToCartUrl = `cart/add`;
            const changeCartUrl = `cart/change`;
            const addToCartViewAjaxUrl = `/cart/?view=ajax`;

            const url = args[0].toString();

            const isCartRelatedCall = url.includes(addToCartUrl) || url.includes(changeCartUrl) || url === addToCartViewAjaxUrl;

            if (isCartRelatedCall) {
                const temp = target.apply(that, args);

                /**
                 * When a product quantity is updated in the cart and there are multiple products, the cart/change route is called multiple times,
                 * which results in excessive calls to the order update API.
                 * Therefore, we need to limit the number of calls to the order update API
                 */
                if (url.includes(changeCartUrl) && shouldThrottle()) {
                    return temp;
                }

                temp.finally(() => {
                    fetch(window.Shopify.routes.root + "cart.js", {
                        method: "GET",
                    })
                        .then((res) => res.json())
                        .then((cart) => {
                            const token = cart.token;
                            const draftOrder = localStorage.getItem("draftOrder");
                            const draftOrderData = draftOrder ? JSON.parse(draftOrder) : null;
                            let draftOrderId = null;

                            if (draftOrderData && draftOrderData[token] && draftOrderData[token].draftOrderId) {
                                draftOrderId = draftOrderData[token].draftOrderId;
                            } else {
                                localStorage.removeItem("draftOrder");
                            }

                            const cartItems = cart.items;
                            updateDraftOrder(
                                cartItems,
                                draftOrderId,
                                getCustomerData(),
                                (result) => {
                                    setDraftOrderToLocalStorage(token, result?.data?.invoiceUrl, result?.data?.draftOrderId, result?.data?.updatedAt);
                                },
                                () => {
                                    localStorage.removeItem("draftOrder");
                                }
                            );
                        })
                        .catch(() => {
                            localStorage.removeItem("draftOrder");
                        });
                }).catch(() => {
                    localStorage.removeItem("draftOrder");
                });

                return temp;
            } else {
                return target.apply(that, args);
            }
        },
    });

    document.addEventListener("DOMContentLoaded", function () {
        document.body.addEventListener("submit", function (event) {
            event.preventDefault();
            const form = event.target;
            if (form.hasAttribute("action") && form.getAttribute("action").includes("/cart")) {
                const boutonsSubmit = document.querySelectorAll('button[type="submit"], input[type="submit"]');
                const toggleButtonsState = (isDisabled) => {
                    boutonsSubmit.forEach((button) => {
                        button.disabled = isDisabled;
                        button.classList.toggle("disabled", isDisabled);
                    });
                };
                toggleButtonsState(true);
                fetch(window.Shopify.routes.root + "cart.js", {
                    method: "GET",
                })
                    .then((res) => res.json())
                    .then((cart) => {
                        const token = cart.token;
                        const draftOrder = localStorage.getItem("draftOrder");
                        const draftOrderData = draftOrder ? JSON.parse(draftOrder) : null;
                        // Target: expiration reduced from 60 days to 59.99 days for security reasons
                        const draftOrderExpirationDays = 59.99;
                        const draftOrderExpirationDate = new Date();
                        draftOrderExpirationDate.setDate(draftOrderExpirationDate.getDate() - draftOrderExpirationDays);

                        if (draftOrderData && draftOrderData[token] && draftOrderData[token].draftOrderUrl) {
                            if (draftOrderData[token].updatedAt && new Date(draftOrderData[token].updatedAt) > draftOrderExpirationDate) {
                                toggleButtonsState(false);
                                window.location.href = draftOrderData[token].draftOrderUrl;
                            } else {
                                const cartItems = cart.items;
                                updateDraftOrder(
                                    cartItems,
                                    null,
                                    getCustomerData(),
                                    (result) => {
                                        toggleButtonsState(false);
                                        setDraftOrderToLocalStorage(token, result?.data?.invoiceUrl, result?.data?.draftOrderId, result?.data?.updatedAt);
                                        window.location.href = result.data.invoiceUrl;
                                    },
                                    () => {
                                        toggleButtonsState(false);
                                        localStorage.removeItem("draftOrder");
                                        form.submit();
                                    }
                                );
                            }
                        } else {
                            const cartItems = cart.items;
                            updateDraftOrder(
                                cartItems,
                                null,
                                getCustomerData(),
                                (result) => {
                                    toggleButtonsState(false);
                                    setDraftOrderToLocalStorage(token, result?.data?.invoiceUrl, result?.data?.draftOrderId, result?.data?.updatedAt);
                                    window.location.href = result.data.invoiceUrl;
                                },
                                () => {
                                    toggleButtonsState(false);
                                    localStorage.removeItem("draftOrder");
                                    form.submit();
                                }
                            );
                        }
                    });
            } else {
                form.submit();
            }
        });
    });
}